<template>
    <form @submit.prevent="runFinderFxn">
        <div class="input-group">
            <!-- show search box -->
            <input v-model="finderBox" type="text" 
                class="form-control nav-search-input no-lines bg-white" 
                placeholder="Search aNewItem">
            
            <!-- the search icon -->
            <div @click.prevent="runFinderFxn" class="input-group-append clickable">
                <span class="input-group-text bg-light text-dark-green">
                    <i class="fas fa-search mx-2"></i>
                </span>
            </div>
        </div>
    </form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: "Search",
    props: {
        finderText: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            finderBox: ''
        }
    },
    methods: {
        ...mapActions(['']),
        runFinderFxn() {
            this.$router.push({
                name: 'site-search',
                params: { query: this.finderBox }
            }).catch((e) => {})
        },
        updateFinderText(newSearch) {
            if(!newSearch) return
            this.finderBox = newSearch
        }
    },
    watch: {
        '$route.params.query'() {
            this.updateFinderText(this.$route.params.query)
        },
        '$route.params.category'() {
            this.updateFinderText(this.$route.params.category)
        },
    },
    created() {
        // display the searched text or category selected by user
        this.updateFinderText(this.$route.params.query)
        this.updateFinderText(this.$route.params.category)
    }
}
</script>